import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$axios = axios;
//超时时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = true;

// 请求拦截（配置发送请求的信息）
axios.interceptors.request.use(function (config) {
    // 处理请求之前的配置
    return config
}, function (error) {
    // 请求失败的处理
    return Promise.reject(error)
})
axios.interceptors.response.use((response) => {
        // 对响应数据做点什么
        // return response.data
        if (typeof response.data == 'string') {
            window.location.href = baseUrl + '/login/appLogin'
        } else {
            return response.data
        }
    },
    function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);
